// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"b4f95727","667":"5d0973ea","977":"49a6fd65"}[chunkId] + ".chunk.js";
};